import React from "react";
import SectionOne from "components/pages/web/home/sectionOne";
import Advantages from "components/pages/web/home/advantages";
import Media from "components/pages/web/home/media";
import Guide from "components/pages/web/home/guide";
import FreindsReferral from "components/pages/web/home/frindReferral/freindsReferral ";
import Services from "components/pages/web/home/services";
import Academy from "components/pages/web/home/academy";
import BestPriceTable from "components/pages/web/home/bestPriceTable";
import "assets/styles/components/home.scss";
const Index = () => {
  return (
    <>
      <SectionOne />
      <BestPriceTable />
      <Advantages />
      <Guide />
      <Services />
      <FreindsReferral />
      <Academy />
      <Media />
    </>
  );
};

export default Index;
